<div
  class="upload-dialog"
>
  <ng-container *ngIf="!isUploading && !finished">
    <label
      class="upload-area"
      (fileOver)="fileOver($event)"
      (onFileDrop)="upload()"
      [uploader]="uploader"
      ng2FileDrop
    >
      <nb-icon icon="cloud-upload-outline"/>
      <span class="clr-black-base fs-24 fw-700  ">
        Загрузить файлы
      </span>
      <span class="clr-black-base fs-14 fw-400">
        Нажмите, чтобы загрузить файл, либо перетащите сюда
      </span>
      <span class="clr-grey-sec fs-14 fw-400 ">
        любой формат до 4 ГБ
      </span>

      <input ng2FileSelect
             (change)="upload()" [uploader]="uploader"
             class="files-input"
             type="file"
             multiple
      >
    </label>
  </ng-container>

  <ng-container *ngIf="isUploading">
    <div class="progress-bar-container">
      <svg>
        <circle cx="50" cy="50" r="50"></circle>
        <circle
          [style]="getProgressStyle(progress)"
          cx="50" cy="50" r="50"
        ></circle>
      </svg>

      <span class="progress-bar-counter">
        {{ progress }}%
      </span>
    </div>

    <span class="clr-black-base fs-24 fw-700  ">
      Загрузка файлов в папку name
    </span>
    <span class="clr-grey-sec fs-14 fw-400 ">
      {{ createLabel(files.length, 'Загружен|Загружено|Загружено') }} файлов {{ files.length }} из {{ uploader.queue.length }}
    </span>
  </ng-container>

  <ng-container *ngIf="finished">
    <nb-icon (click)="restart()" icon="repeat-outline"></nb-icon>

    <nb-icon icon="cloud-upload-outline"/>

    <span class="clr-black-base fs-24 fw-700 ">
      Загрузка файлов завершена
    </span>
    <span class="clr-grey-sec fs-14 fw-400 ">
      Загружено {{ files.length }} {{ createLabel(files.length, 'файл|файла|файлов') }} в папку
    </span>
  </ng-container>
</div>
